import { TextField } from "@mui/material";
import styled from "styled-components";
import { colors } from "../../../../theme/colors";

export const StyledTextInput = styled(TextField)`
  margin-top: 0rem !important;
  margin-bottom: 0rem !important;

  & label.Mui-focused {
    color: ${colors.secondary};
  }
  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: ${colors.secondary};
    }
  }
`;
